module.exports = __webpack_public_path__ + "img/can-tho.8bc075dc.png";